module.exports = __webpack_public_path__ + "static/media/weektc.546c4d9a.png";